import React from 'react';
import { Box, Typography} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import SchoolIcon from "@mui/icons-material/School";
import FacebookIcon from "@mui/icons-material/Facebook";
import footerStyle from "./footerStyle";
import { useHandleClick } from '../../utils/clickHandlers.js';
import FooterLink from './components/FooterLink.js';
import SocialIcon from './components/SocialIcon.js';

const Footer = () => {
  const classes = footerStyle();
  const handleClick = useHandleClick();

  return (
    <Box className={classes.footerContainer}>

      <Box className={classes.linksContainer}>
        <FooterLink href="/">Paketpost Horizons</FooterLink>
        <FooterLink href="/" onClick={(event) => handleClick(event, 'project')}>Project</FooterLink>
        <FooterLink href="/" onClick={(event) => handleClick(event, 'viewerToggle')}>Model Viewer</FooterLink>
        <FooterLink href="/" onClick={(event) => handleClick(event, 'about-us')}>About Us</FooterLink>
      </Box>

      <Box className={classes.iconsContainer}>
        <SocialIcon href="https://github.com" icon={GitHubIcon} />
        <SocialIcon href="https://www.tum.de" icon={SchoolIcon} />
        <SocialIcon href="https://facebook.com" icon={FacebookIcon} />
      </Box>

      {/* Right Section */}
      <Typography variant="body2" className={classes.copyright}>
        © 2025 PaketPost Horizons. All rights reserved.
      </Typography>
    </Box>

  );
};

export default Footer;